import React from 'react';
import ErrorBoundary from './ErrorBoundary';

interface PageErrorBoundaryProps {
  pageName: string;
  children: React.ReactNode;
}

const PageErrorBoundary: React.FC<PageErrorBoundaryProps> = ({ pageName, children }) => (
  <ErrorBoundary
    name={pageName}
    fallback={
      <div className="page-error" role="alert">
        <h2>Unable to load {pageName}</h2>
        <p>Please refresh the page or contact support if the problem persists.</p>
      </div>
    }
  >
    {children}
  </ErrorBoundary>
);

export default PageErrorBoundary;
